// ** React Imports
import { useContext } from "react";
import { generatePath } from "react-router-dom";

// ** Custom Components
import Block from "components/layout/Block";
import UserAvatar from "components/user/UserAvatar";
import Login from "components/user/Login";
import Link from "components/layout/Link";

// ** Containers
import routes from "containers";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const LoginAvatarSmall = ({
	data,
	size,
	margin,
	fullWidth,
	maxWidthWithEllipsis,
	direction = true,
	vipProps,
	loginSize,
	additional = null,
}) => {
	const { login = "" } = data || {};
	const to = generatePath(routes.user.path, {
		login: login?.toLowerCase(),
	});

	const { isPhone } = useContext(deviceTypeContext);

	// #####################################################

	return (
		<Block
			flex
			column={direction && isPhone}
			alignCenter
			mx={margin ? 1 : 0}
		>
			<Link to={to} underline>
				<UserAvatar
					userId={data?.user_id || data?.id}
					size={size}
					src={data.user_avatar || data.avatar}
					online={data.online}
					status={data.profile_status}
					privateData={data.private_data}
				/>
			</Link>
			{/* minWidth: 0 - to fix auto scaling width (and ellipsis) in table cell */}
			<Block fullWidth={fullWidth} style={{ minWidth: 0 }}>
				<Link to={to} underline>
					<Login
						oneLine={direction && isPhone}
						maxWidthWithEllipsis={maxWidthWithEllipsis}
						login={data ? data.login : ""}
						vip={data.status_vip}
						ml={typeof additional === "function" ? 3 : 2}
						size={loginSize || (isPhone ? "xbase" : "medium")}
						vipProps={{
							height: 14,
							marginBottom: 0.125,
							...vipProps,
						}}
					/>
				</Link>
				{typeof additional === "function" && (
					<Block ml={3}>{additional()}</Block>
				)}
			</Block>
		</Block>
	);
};

export default LoginAvatarSmall;
